import * as groupedManagement from './groupedManagement';
import * as trackingSchedule from './trackingSchedule';
import * as lostSalesReport from './lostSalesReport';
import * as specialOrders from './specialOrders';
import * as possDownload from './possDownload';
import * as immobilized from './immobilized';
import * as stockOrders from './stockOrders';
import * as management from './management';
import * as tracking from './tracking';
import * as emerging from './emerging';
import * as etaManagement from './etaManagement';

const Actions = {
  ...groupedManagement,
  ...trackingSchedule,
  ...etaManagement,
  ...lostSalesReport,
  ...specialOrders,
  ...possDownload,
  ...stockOrders,
  ...immobilized,
  ...management,
  ...emerging,
  ...tracking,
};

export default Actions;
